/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { reaction } from 'mobx';
import React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { AuthoringRegion } from 'src/core/types/regionTypes';
import { GlobalEnvironmentMetadata } from 'src/core/utils/GlobalEnvironmentMetadata';

/**
 * Initializes the singleton GlobalEnvironmentMetadata instance,
 * and subscribes to any future changes and reflects them on the instance.
 */
export const useInitializeGlobalEnvironment = () => {
    const { rootStore } = useGlobalState();

    React.useEffect(
        () =>
            reaction(
                () => [rootStore.serviceKey, rootStore.azureStore.session.csAccountStore] as const,
                ([serviceKey, csAccount]) => {
                    GlobalEnvironmentMetadata.instance.serviceKey = serviceKey;
                    GlobalEnvironmentMetadata.instance.region = <AuthoringRegion>csAccount?.region;
                    GlobalEnvironmentMetadata.instance.endpoint = csAccount?.endpoint;
                    GlobalEnvironmentMetadata.instance.currentResourceKind = csAccount?.kind;
                }
            ),
        [rootStore]
    );
};
